"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var HeaderAction = function HeaderAction(_ref) {
  var _ref$invert = _ref.invert,
      invert = _ref$invert === void 0 ? false : _ref$invert,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      icon = _ref.icon,
      title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["invert", "className", "icon", "title"]);
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: title
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: (0, _classnames["default"])('p-3 mx-1 cursor-pointer', {
      'hover:text-primary': !invert,
      'hover:text-dark': invert
    }, className)
  }), icon));
};

var _default = HeaderAction;
exports["default"] = _default;
//# sourceMappingURL=index.js.map